import { Sprite } from 'pixijs/sprite';

import type { CanvasRenderer } from 'pixijs/renderer/canvas';

/**
 * Cached tinted texture.
 * @memberof PIXI.Sprite#
 * @member {PIXI.ICanvas | HTMLImageElement} _tintedCanvas
 * @protected
 */
Sprite.prototype._tintedCanvas = null;

/**
 * Renders the object using the Canvas renderer
 * @private
 * @method _renderCanvas
 * @memberof PIXI.Sprite#
 * @param {PIXI.CanvasRenderer} renderer - The renderer
 */
Sprite.prototype._renderCanvas = function _renderCanvas(renderer: CanvasRenderer): void
{
    renderer.plugins.sprite.render(this);
};
